import axios from 'axios';

import {
    accountRequest,
    accountFail,
    categoriesSuccess,
    daySummarySuccess,
    monthlySummarySuccess,
    categorySummarySuccess,
    entryAddedSuccess,
    entryDeletedSuccess,
    openingSetSuccess
} from '../slices/accountSlice';

export const getAccountCategories = () => async (dispatch) => {
    try {
        dispatch(accountRequest());
        const { data } = await axios.get(`/api/v1/admin/accounts/categories`);
        dispatch(categoriesSuccess(data));
    } catch (error) {
        dispatch(accountFail(error.response.data.message));
    }
}

export const getDaySummary = date => async (dispatch) => {
    try {
        dispatch(accountRequest());
        const { data } = await axios.get(`/api/v1/admin/accounts/day?date=${date}`);
        dispatch(daySummarySuccess(data));
    } catch (error) {
        dispatch(accountFail(error.response.data.message));
    }
}

export const getMonthlySummary = (year, month) => async (dispatch) => {
    try {
        dispatch(accountRequest());
        const { data } = await axios.get(`/api/v1/admin/accounts/monthly?year=${year}&month=${month}`);
        dispatch(monthlySummarySuccess(data));
    } catch (error) {
        dispatch(accountFail(error.response.data.message));
    }
}

export const getCategorySummary = (type, from, to, category) => async (dispatch) => {
    try {
        dispatch(accountRequest());
        let link = `/api/v1/admin/accounts/by-category?`;
        if (type) link += `type=${type}&`;
        if (from) link += `from=${from}&`;
        if (to) link += `to=${to}&`;
        if (category) link += `category=${encodeURIComponent(category)}&`;
        const { data } = await axios.get(link);
        dispatch(categorySummarySuccess(data));
    } catch (error) {
        dispatch(accountFail(error.response.data.message));
    }
}

export const addAccountEntry = entryData => async (dispatch) => {
    try {
        dispatch(accountRequest());
        await axios.post(`/api/v1/admin/accounts/entry`, entryData);
        dispatch(entryAddedSuccess());
    } catch (error) {
        dispatch(accountFail(error.response.data.message));
    }
}

export const deleteAccountEntry = id => async (dispatch) => {
    try {
        dispatch(accountRequest());
        await axios.delete(`/api/v1/admin/accounts/entry/${id}`);
        dispatch(entryDeletedSuccess());
    } catch (error) {
        dispatch(accountFail(error.response.data.message));
    }
}

export const setOpeningBalance = (date, amount) => async (dispatch) => {
    try {
        dispatch(accountRequest());
        await axios.put(`/api/v1/admin/accounts/opening`, { date, amount });
        dispatch(openingSetSuccess());
    } catch (error) {
        dispatch(accountFail(error.response.data.message));
    }
}
